<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label>{{ $tc('tenants.title', 1) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="tenantFilter"
          :options="tenantOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:tenantFilter', val)"
          data-cy="tenantFilter"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label>{{ $t("tenants.store.storage_service") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="storageServiceFilter"
          :options="storageService"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:storageServiceFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>

      <b-col cols="6" class="mb-2">
        <b-row>
          <b-col cols="8" class="mb-0">
            <label>{{ $t('tenants.store.assigned_space_min') }}</label>
            <b-form-input
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="assignedSpaceMin"
              class="w-100"
              type="number"
              step=".01"
              :reduce="(val) => val.value"
              @input="(val) => $emit('update:assignedSpaceMin', val)"
              append-to-body
              :calculate-position="withPopper"
            />
          </b-col>
          <b-col cols="4" class="mb-0">
            <label>{{ $t("tenants.store.type") }}</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="assignedSpaceMinType"
              :options="sizeOptions"
              class="w-100"
              :reduce="(val) => val.value"
              @input="(val) => $emit('update:assignedSpaceMinType', val)"
              append-to-body
              :calculate-position="withPopper"
            />
          </b-col>
        </b-row>
      </b-col>


      <b-col cols="6" class="mb-2">
        <b-row>
          <b-col cols="8" class="mb-0">
            <label>{{ $t('tenants.store.assigned_space_max') }}</label>
            <b-form-input
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="assignedSpaceMax"
              class="w-100"
              type="number"
              step=".01"
              :reduce="(val) => val.value"
              @input="(val) => $emit('update:assignedSpaceMax', val)"
              append-to-body
              :calculate-position="withPopper"
            />
          </b-col>
          <b-col cols="4" class="mb-0">
            <label>{{ $t("tenants.store.type") }}</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="assignedSpaceMaxType"
              :options="sizeOptions"
              class="w-100"
              :reduce="(val) => val.value"
              @input="(val) => $emit('update:assignedSpaceMaxType', val)"
              append-to-body
              :calculate-position="withPopper"
            />
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="6" class="mb-2">
        <b-row>
          <b-col cols="8" class="mb-0">
            <label>{{ $t('tenants.store.used_space_min') }}</label>
            <b-form-input
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="usedSpaceMin"
              class="w-100"
              type="number"
              step=".01"
              :reduce="(val) => val.value"
              @input="(val) => $emit('update:usedSpaceMin', val)"
              append-to-body
              :calculate-position="withPopper"
            />
          </b-col>
          <b-col cols="4" class="mb-0">
            <label>{{ $t("tenants.store.type") }}</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="usedSpaceMinType"
              :options="sizeOptions"
              class="w-100"
              :reduce="(val) => val.value"
              @input="(val) => $emit('update:usedSpaceMinType', val)"
              append-to-body
              :calculate-position="withPopper"
            />
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="6" class="mb-2">
        <b-row>
          <b-col cols="8" class="mb-0">
            <label>{{ $t('tenants.store.used_space_max') }}</label>
            <b-form-input
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="usedSpaceMax"
              class="w-100"
              type="number"
              step=".01"
              :reduce="(val) => val.value"
              @input="(val) => $emit('update:usedSpaceMax', val)"
              append-to-body
              :calculate-position="withPopper"
            />
          </b-col>
          <b-col cols="4" class="mb-0">
            <label>{{ $t("tenants.store.type") }}</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="usedSpaceMaxType"
              :options="sizeOptions"
              class="w-100"
              :reduce="(val) => val.value"
              @input="(val) => $emit('update:usedSpaceMaxType', val)"
              append-to-body
              :calculate-position="withPopper"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
} from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
  },
  props: {
    tenantOptions: {
      type: Array,
      default: null,
    },
    tenantFilter: {
      type: Array,
      default: null,
    },
    storageService: {
      type: Array,
      default: null,
    },
    storageServiceFilter: {
      type: Array,
      default: null,
    },
    sizeOptions: {
      type: Array,
      default: null,
    },
    assignedSpaceMinType: {
      type: String,
      default: null,
    },
    assignedSpaceMaxType: {
      type: String,
      default: null,
    },
    assignedSpaceMin: {
      type: String,
      default: null,
    },
    assignedSpaceMax: {
      type: String,
      default: null,
    },
    usedSpaceMinType: {
      type: String,
      default: null,
    },
    usedSpaceMaxType: {
      type: String,
      default: null,
    },
    usedSpaceMin: {
      type: String,
      default: null,
    },
    usedSpaceMax: {
      type: String,
      default: null,
    },
  },
  
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
